export function getVariantDisplayQuantity(variant: {
  net_quantity?: string | null;
  quantity?: string | number | null;
  unit?: string | null;
} | null | undefined): string {
  if (!variant) return '';
  const netQuantity = variant.net_quantity?.trim();
  if (netQuantity) return netQuantity;
  return [variant.quantity, variant.unit?.trim()]
    .filter(value => value !== null && value !== undefined && value !== '')
    .join(' ');
}
